<div class="p-payment-method-finance__item">
  <span class="u-visually-hidden" [innerHTML]="'alt.paypal' | staticMsg"></span>
  <h3
    class="p-payment-method-finance__item-title p-payment-method-finance__item-title--m p-sub-column-layout01__list-item"
    [innerHTML]="'alt.paypal' | staticMsg"
  ></h3>
  <div class="p-payment-method-finance__item-contents" [innerHTML]="'message.paypalDescription' | staticMsg"></div>
  <span class="l-tab-menu01__menu-title">
    <span class="l-tab-menu01__menu-title-icon"
      ><img src="assets/images/logo_paypal.svg" width="88" height="33" alt="{{ 'alt.paypal' | staticMsg }}"
    /></span>
  </span>
</div>
